:host {
    display: block;

    .content {
        height: 0;
        overflow: hidden;
        background-color: $color-grey-06-bright;
        animation: fadeOut 500ms forwards;
    }

    button {
        width: 100%;
        display: flex;
        align-items: center;
        border: 0;
        border-bottom: 2px solid $color-white;
        padding: 0;

        span {
            @include typo-ws-paragraph-bold;

            color: $color-grey-01-dark;
            width: 100%;
            text-align: start;
            padding-left: 20px;
        }

        .svg {
            color: $color-red;
            flex-shrink: 0;
        }

        .service-icon {
            height: 40px;
            width: 40px;
            padding: 20px;
        }

        .chevron-icon {
            height: 32px;
            width: 32px;
            padding: 0 24px;
            transition: transform 0.2s linear;
            transform-origin: center;
        }
    }

    ::slotted(sew-ws-teaser) {
        margin-top: 0;
        padding: 32px 0 40px;
    }
}

:host([active]) {
    button {
        .chevron-icon {
            transform: rotate(-180deg);
        }
    }

    .content {
        animation: fadeIn 500ms forwards;
    }
}

@include mq-2-min {
    :host {
        button {
            display: none;
        }

        ::slotted(sew-ws-teaser) {
            padding: 40px 0;
        }
    }

    :host([open-content]) {
        .content {
            animation: fadeIn 500ms forwards 500ms;
        }
    }
}

@keyframes fadeIn {
    from {
        height: 0;
        border-bottom: 0;
    }

    99% {
        height: var(--content-height);
        overflow: hidden;
    }

    to {
        overflow: visible;
        height: auto;
        border-bottom: 2px solid $color-white;
    }
}

@keyframes fadeOut {
    from {
        overflow: visible;
        height: auto;
        border-bottom: 2px solid $color-white;
    }

    1% {
        height: var(--content-height);
        overflow: hidden;
    }

    to {
        height: 0;
        border-bottom: 0;
    }
}
